import { Leaf, Zap, Sun, PanelsTopLeft, Signal, Gift, Rocket, ArrowRight } from "lucide-react";
import { products, whatsappUrl } from "../mock";

const iconMap = { Leaf, Zap, Sun, PanelsTopLeft, Signal, Gift };

export default function Products() {
  return (
    <section id="produtos" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-emerald-100 text-emerald-700 text-xs font-semibold mb-4">
            Portfólio Completo
          </div>
          <h2 className="text-slate-900 text-3xl md:text-5xl font-extrabold leading-tight">
            6 Produtos para Você <span className="green-gradient-text">Oferecer e Ganhar</span>
          </h2>
          <p className="mt-5 text-slate-600 max-w-2xl mx-auto">
            Com a plataforma iGreen Connect, você tem acesso a um portfólio completo de soluções para diferentes perfis de clientes.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {products.map((p) => {
            const Icon = iconMap[p.icon];
            return (
              <div
                key={p.title}
                className="group relative rounded-2xl border border-slate-200 bg-white p-6 hover:border-emerald-400 hover:shadow-2xl hover:-translate-y-1 transition-all"
              >
                <div className="w-12 h-12 rounded-xl bg-emerald-100 text-emerald-600 grid place-items-center group-hover:bg-emerald-500 group-hover:text-white transition-colors">
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="mt-4 text-slate-900 font-bold text-xl">{p.title}</h3>
                <p className="mt-2 text-slate-600 leading-relaxed text-sm">{p.text}</p>
                <div className="mt-4 inline-flex items-center px-3 py-1 rounded-full bg-emerald-50 text-emerald-700 text-xs font-semibold border border-emerald-100">
                  {p.tag}
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-10 rounded-3xl bg-gradient-to-r from-emerald-700 to-emerald-600 p-8 md:p-10 text-white flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-xl bg-white/15 grid place-items-center">
              <Rocket className="w-6 h-6 text-amber-300" />
            </div>
            <div>
              <h3 className="text-2xl font-bold">Conexão Expansão</h3>
              <p className="text-emerald-50 mt-1 max-w-xl">
                Além de ganhar com seus clientes, você pode formar equipe e ganhar <span className="font-bold text-amber-300">R$300 + royalties</span> por cada novo licenciado indicado. Multiplique sua rede e seus ganhos!
              </p>
            </div>
          </div>
          <a href={whatsappUrl} target="_blank" rel="noreferrer" className="btn-gold inline-flex items-center gap-2 px-6 py-3 rounded-xl text-sm whitespace-nowrap">
            Saber Mais <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
